import { EmptyValuePlaceholder } from "@/components/ui"
import Address, { SingleLineAddress } from "@/components/Address"
import { formatDate, formatPrice } from '@/utils/formatters'

import { getFactureStatusLabel } from '@/features/entretiens/entretiensSlice'

export default ({item}) => {
  return(
    <div className="card bg-primary-200 w-full md:w-[calc(50%-0.5rem)]">
      <div className="card-body p-4 bg-base-200">
        <div className="grid grid-cols-2 gap-2">

          <div className="text-sm font-medium text-gray-600">Type d'entretien</div>
          <div>{item.entretien_type_nom || <EmptyValuePlaceholder />}</div>

          <div className="text-sm font-medium text-gray-600">Date</div>
          <div>{formatDate(item.date_prestation) || <EmptyValuePlaceholder />}</div>
          
          <div className="text-sm font-medium text-gray-600">Adresse</div>
          <div>
            <SingleLineAddress data={item.bien} apptNumberPrefix={true} />
          </div>

          <div className="text-sm font-medium text-gray-600">Montant</div>
          <div>{formatPrice(item.montant) || <EmptyValuePlaceholder />}</div>

          { item.facture_adresse &&
            <div className="col-span-2">
              <div className="text-sm font-medium text-gray-600 mb-1">Entité à facturer</div>
              <div>
                  <div>{item.facture_adresse?.nom || ''}</div>
                  { item.facture_adresse?.complement && 
                    <div className="uppercase">{item.facture_adresse.complement}</div>
                  }
                  <Address data={item?.facture_adresse || {}}/>
              </div>
            </div>
          }

          <div className="text-sm font-medium text-gray-600">Statut facture</div>
          <div>{getFactureStatusLabel(item.statut_facture) || <EmptyValuePlaceholder />}</div>

        </div>
      </div>
    </div>
  )
}